module.exports = __webpack_public_path__ + "static/media/prop-10.a562d398.png";